/* Returned Parcels — Billed To cell (click = copy, double-click = edit) + group-by header row. */
import { useRef, useState } from "react";
import { toast } from "sonner";
import { Copy, FileSpreadsheet, Printer } from "lucide-react";
import { excelVoucher, printVoucher } from "@/components/ReturnVoucher";

const copy = (name) => navigator.clipboard.writeText(name).then(() => toast.success(`Copied: ${name}`));

export const BilledToCell = ({ row, onSave }) => {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState("");
  const timer = useRef(null);
  const commit = async () => {
    const v = val.trim();
    setEditing(false);
    if (v !== (row.billed_to || "")) await onSave(v);
  };
  if (editing) return (
    <input autoFocus value={val} onChange={e => setVal(e.target.value)} onBlur={commit}
      onKeyDown={e => { if (e.key === "Enter") commit(); if (e.key === "Escape") setEditing(false); }}
      placeholder="Billed-to name ↵"
      className="w-40 rounded border border-indigo-400 px-1.5 py-0.5 text-xs focus:outline-none focus:ring-2 focus:ring-indigo-200"
      data-testid={`rp-billed-to-input-${row.id}`} />
  );
  return (
    <div className="cursor-text" title="Click to copy · double-click to edit"
      onClick={() => { if (!row.billed_to) return; clearTimeout(timer.current); timer.current = setTimeout(() => copy(row.billed_to), 230); }}
      onDoubleClick={() => { clearTimeout(timer.current); setVal(row.billed_to || ""); setEditing(true); }}
      data-testid={`rp-billed-to-copy-${row.id}`}>
      {row.billed_to ? (
        <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-emerald-50 text-emerald-800 font-semibold hover:bg-emerald-100 transition-colors">
          {row.billed_to} <Copy className="w-3 h-3 opacity-60" />
        </span>
      ) : <span className="text-slate-400 italic">— dbl-click —</span>}
    </div>
  );
};

export const BilledToGroupRow = ({ name, parcels, qty, colSpan, rows = [] }) => (
  <tr className="bg-emerald-50/70 border-t-2 border-t-emerald-500" data-testid={`rp-group-${name || "none"}`}>
    <td colSpan={colSpan} className="px-3 py-1.5 text-xs">
      <span className="font-semibold text-slate-500 mr-1">Billed To:</span>
      <b className="text-emerald-900 text-sm">{name || "Not set"}</b>
      <span className="ml-3 text-slate-600">{parcels} parcel{parcels === 1 ? "" : "s"} · qty {qty}</span>
      {name && (
        <button type="button" onClick={() => copy(name)} data-testid={`rp-group-copy-${name}`}
          className="ml-3 inline-flex items-center gap-1 rounded-full border border-emerald-300 bg-white px-2 py-0.5 text-[11px] font-semibold text-emerald-700 hover:bg-emerald-100 transition-colors">
          <Copy className="w-3 h-3" /> Copy name
        </button>
      )}
      <button type="button" onClick={() => { if (!printVoucher(name, rows)) toast.error("Allow pop-ups to print"); }}
        data-testid={`rp-group-voucher-print-${name || "none"}`}
        className="ml-2 inline-flex items-center gap-1 rounded-full bg-emerald-600 hover:bg-emerald-700 px-2.5 py-0.5 text-[11px] font-semibold text-white transition-colors">
        <Printer className="w-3 h-3" /> Print voucher
      </button>
      <button type="button" onClick={() => excelVoucher(name, rows)} data-testid={`rp-group-voucher-excel-${name || "none"}`}
        className="ml-1 inline-flex items-center gap-1 rounded-full border border-emerald-300 bg-white px-2 py-0.5 text-[11px] font-semibold text-emerald-700 hover:bg-emerald-100 transition-colors">
        <FileSpreadsheet className="w-3 h-3" /> Excel
      </button>
    </td>
  </tr>
);
